import { render, staticRenderFns } from "./svg-icon.tmpl.vue?vue&type=template&id=376a4550&scoped=true&"
import script from "./svg-icon.tmpl.vue?vue&type=script&lang=js&"
export * from "./svg-icon.tmpl.vue?vue&type=script&lang=js&"
import style0 from "./svg-icon.tmpl.vue?vue&type=style&index=0&id=376a4550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376a4550",
  null
  
)

export default component.exports